import { fmtBRL } from "@/lib/api";
import { ArrowLeft, ArrowRight, CheckCircle } from "@phosphor-icons/react";
import { MONTH_NAMES, WEEK_LABELS, METHOD_LABELS, METHOD_COLORS, iso } from "@/components/finance/apShared";

export default function BillsCalendar({
  cursor, setCursor, grid, billsByDay, monthTotal, paidTotal, onNewBill, onPay, onEdit,
}) {
  const today = new Date();
  const isToday = (d) => d && iso(d) === iso(today);
  const isPast = (d) => d && iso(d) < iso(today);

  return (
    <>
      {/* Header do calendário */}
      <div className="flex items-center justify-between mb-4">
        <button className="btn btn-ghost" onClick={() => setCursor(new Date(cursor.getFullYear(), cursor.getMonth() - 1, 1))} data-testid="cal-prev"><ArrowLeft size={16} /> Anterior</button>
        <div className="text-center">
          <div className="overline text-zinc-500">MÊS</div>
          <div className="font-head text-2xl font-black" data-testid="cal-month-label">{MONTH_NAMES[cursor.getMonth()]} {cursor.getFullYear()}</div>
          <div className="text-xs text-zinc-500 mt-1">
            Pendente: <span className="font-mono font-bold text-[#E60000]">{fmtBRL(monthTotal)}</span>
            {paidTotal > 0 && <span className="ml-3">Pago: <span className="font-mono font-bold text-[#00A300]">{fmtBRL(paidTotal)}</span></span>}
          </div>
        </div>
        <button className="btn btn-ghost" onClick={() => setCursor(new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1))} data-testid="cal-next">Próximo <ArrowRight size={16} /></button>
      </div>

      {/* Legenda dias da semana */}
      <div className="grid grid-cols-7 border border-black border-b-0" data-testid="cal-headers">
        {WEEK_LABELS.map((w, wi) => (
          <div key={`${w}-${wi}`} className="p-2 text-center font-mono font-bold text-xs uppercase tracking-widest bg-zinc-100 border-r border-black last:border-r-0">
            {w}
          </div>
        ))}
      </div>

      {/* Grid do calendário */}
      <div className="grid grid-cols-7 border border-black bg-black gap-[1px]" data-testid="calendar">
        {grid.map((d, idx) => {
          const cellKey = d ? `day-${iso(d)}` : `empty-${idx}`;
          return (
          <div
            key={cellKey}
            className={`bg-white min-h-[110px] p-2 ${d ? "cursor-pointer hover:bg-yellow-50" : ""} ${isToday(d) ? "!bg-[#FFF9E0] ring-2 ring-[#FFC000] relative z-10" : ""}`}
            onClick={() => d && onNewBill(d)}
            data-testid={d ? `cal-day-${iso(d)}` : `cal-empty-${idx}`}
          >
            {d && (
              <>
                <div className="flex items-center justify-between mb-1">
                  <span className={`font-mono font-bold text-sm ${isPast(d) && !isToday(d) ? "text-zinc-400" : "text-black"}`}>
                    {d.getDate()}
                  </span>
                  {isToday(d) && <span className="text-[9px] font-bold uppercase tracking-widest bg-[#FFC000] text-black px-1">HOJE</span>}
                </div>
                <div className="space-y-1">
                  {(billsByDay[iso(d)] || []).slice(0, 3).map((b) => (
                    <div
                      key={b.id}
                      onClick={(e) => {
                        e.stopPropagation();
                        // Se pendente → abre modal "dar baixa". Se pago → apenas edita.
                        if (b.status === "pending") onPay(b);
                        else onEdit(b);
                      }}
                      className={`text-[10px] px-1.5 py-1 border cursor-pointer hover:opacity-80 ${b.status === "paid" ? "bg-[#E8F5E9] border-[#00A300] text-[#00695C]" : "border-[#E60000]"}`}
                      style={{ borderLeftWidth: 3, borderLeftColor: METHOD_COLORS[b.payment_method] || "#000" }}
                      title={b.status === "paid"
                        ? `PAGO em ${b.paid_at || ""} · ${fmtBRL(b.amount)}`
                        : `Clique para dar baixa · ${b.supplier_name} · ${fmtBRL(b.amount)} · ${METHOD_LABELS[b.payment_method] || b.payment_method}`}
                      data-testid={`bill-chip-${b.id}`}
                    >
                      <div className="font-bold truncate flex items-center gap-1">
                        {b.status === "paid" && <CheckCircle size={9} weight="fill" />}
                        {b.supplier_name || "—"}
                      </div>
                      <div className={`font-mono ${b.status === "paid" ? "line-through opacity-70" : ""}`}>{fmtBRL(b.amount)}</div>
                    </div>
                  ))}
                  {(billsByDay[iso(d)] || []).length > 3 && (
                    <div className="text-[10px] text-zinc-500 font-mono">+ {billsByDay[iso(d)].length - 3} mais</div>
                  )}
                </div>
              </>
            )}
          </div>
          );
        })}
      </div>
    </>
  );
}
